import React, {Component} from 'react';
import media from '../MediaQueries.js';
import styled from 'styled-components';

import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem,
        NavLink, Container, Row, Col, Jumbotron, Button } from 'reactstrap';
import { Link } from 'react-router-dom'
import facesBG from '../media/facesbehindthebucketbackground.jpg'
import axios from 'axios';


export default class FacesSection extends Component {
  static propTypes = {
  }

  constructor(props) {
    super(props);

    this.state = {
    	facesArray: [],
    	facesLoaded: false
    };
  }

  componentDidMount() {
  	this.setFacesState();
  }

  setFacesState = () => {
    axios.get('https://s3.amazonaws.com/pattersonmaplefarmsstorage/faces/info/Faces.json')
      .then(response => {
        this.setState({
          facesArray: response.data
        }, () => this.setState({facesLoaded: true}) );
        
      })
      .catch(error => {
        console.log('Error fetching and parsing data', error);
      });
  }

  render() {

    const FacesView = this.state.facesArray.map((face, index, array) => {
      return face.active ? <FacesCol xs="12"  md="6" lg="4" key={index}>
      	 <h3>{face.name}</h3>
         <FacesImg src={face.imgURL}></FacesImg>
		 <p>{face.description}</p>
      </FacesCol>
      : ""
    });

	return (
	  <FluidContainer id="facesSectionID" fluid>
	    <InternalContainer>
	      <h1>Faces Behind the Bucket</h1>
		  {/*<h3>Meet the team of people behind all of our maple products!</h3>*/}

		  <FacesRow>
			{FacesView}
		  </FacesRow>
			
		  {/*
		  <Row>
			<LeavesImgCol xs="4">
				<LeavesImg src={require("../media/facesBucketLeaves.png")}></LeavesImg>
			</LeavesImgCol>
			<Col xs="8"></Col>
		  </Row>
		  */}

	    </InternalContainer>
	  </FluidContainer>
    );
  }
}

const FacesRow = styled(Row)`
	margin: 30px 0 0 0;
`;
const FacesCol = styled(Col)`
	p { text-align: left; margin: 12px 0 20px 0; }
`;

const FacesImg = styled.img`
	width: 100%;
	height: auto;
`;

const FluidContainer = styled(Container)`
	padding: 20px 0 20px 0!important;
	background-image: url(${facesBG}); 
`;

const InternalContainer = styled(Container)`
	text-align: center;
	h1 { 
		margin: 0 0 20px 0;
	}
`;

const LeavesImgCol = styled(Col)`
`;

const LeavesImg = styled.img`
	height: auto;
	width: 100%;
	max-width: 80px;
	max-height: 90px;
`;

/*
const ListViewContainer = styled(({ listSelected, ...rest }) => <Container {...rest} />)`
  display: ${a => a.listSelected ? "block" : "none"};
  ${media.sm` background-image: url(${smHeroImage}); height: 362px; `}
`;
*/


// WEBPACK FOOTER //
// ./src/components/FacesSection.js